/**
 * Created by klerick on 27.12.16.
 */
'use strict';
angular.module('webtrader').component('listOptions', {
    bindings: {

    },
    templateUrl: BASE_URL+'templates/component.listOptions.html',
    controller: function (OpenListOptions) {

        //Amount, Time
        Object.defineProperties(this, {
            isOpen: {
                get: function () {
                    return OpenListOptions.isOpen;
                }
            },
            data: {
                get: function() {
                    return OpenListOptions.data;
                }
            },
            title: {
                get: function() {
                    return OpenListOptions.type == 'volume' ? gettext('Amount') : gettext('Time');
                }
            }

        });

        this.setData = ($event, value) => {
            $event.preventDefault();
            $event.stopPropagation();
            OpenListOptions.close(value);
        }
    }
});
